<template>
	<v-card flat>
		<v-card-text>
			<h3 class="mb-3 d-sm-none">Сообщения</h3>
			<v-divider class="d-sm-none" />
			<v-row>
				<v-col
					cols="12"
					class="py-0 text-end"
				>
					<v-btn
						small
						elevation="0"
						color="transparent"
						@click="fetchMessages"
					>
						Обновить
						<v-icon small>mdi-refresh</v-icon>
					</v-btn>
				</v-col>
				<v-col
					cols="12"
					class="pt-0"
				>
					<v-card
						ref="messagesBlock"
						elevation="0"
						height="300px"
						style="overflow-y: scroll"
						@mouseover="clearRecentlyCreated"
					>
						<template v-if="messages.data.length > 0">
							<repair-order-message-card
								v-for="(message, key) in messages.data"
								:key="key"
								:message="message"
							/>
						</template>
						<p
							v-else
							class="text-center grey--text"
						>
							Нет сообщений
						</p>
					</v-card>
				</v-col>
				<v-col cols="12">
					<v-form
						ref="newMessage"
						@submit.stop.prevent="sendMessage"
					>
						<v-text-field
							v-model="form.content"
							label=""
							placeholder="Введите сообщение"
							name="content"
							:loading="loading"
							:disabled="loading"
							outlined
							dense
							append-outer-icon="mdi-send"
							@click:append-outer="sendMessage"
						/>
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import RepairOrderMessageCard from '@/components/orders/repair/messages/card';

const EMPTY_FORM = () => ({
	content: '',
});

export default {
	name: 'RepairOrderShowMessages',
	components: { RepairOrderMessageCard },
	props: {
		orderId: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		loading: false,
		form: EMPTY_FORM(),
		messages: {
			data: [],
		},
	}),
	computed: {
		channel() {
			return `orders.repair.${this.orderId}`;
		},
	},
	mounted() {
		this.fetchMessages();
	},
	updated() {
		this.scrollBottom();
	},
	methods: {
		scrollBottom() {
			const elem = this.$refs.messagesBlock.$el;
			elem.scrollTo({
				left: 0,
				top: 1000000,
				behavior: 'smooth',
			})
		},
		async fetchMessages() {
			this.messages = (await this.$http.get(`/api/v2/service/orders/repair/${this.orderId}/messages`)).data;
		},
		async sendMessage() {
			if (!this.form.content) {
				return;
			}
			if (this.loading) {
				return;
			}
			this.loading = true;
			try {
				const formData = new FormData(this.$refs.newMessage.$el);
				this.messages = (await this.$http.post(`/api/v2/service/orders/repair/${this.orderId}/messages`, formData)).data;
				this.form = EMPTY_FORM();
			} catch (e) {
				this.$notify.error('Ошибка отправки сообщения');
			} finally {
				this.loading = false;
			}
		},
		clearRecentlyCreated() {
			this.messages.data = this.messages.data.map(msg => {
				if (msg.hasOwnProperty('recentlyCreated')) {
					delete msg.recentlyCreated;
				}
				return msg;
			})
		},
	},
};
</script>

<style scoped>

</style>
